module.exports = __webpack_public_path__ + "img/sports-trivia-title-icon.39e78e9e.png";